import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { Box, Spinner } from '@chakra-ui/react';

import { useHeader } from '@app/components/common/navigation/hooks/header-service';
import { useAlert } from '@app/hooks/use-alert';
import { api } from '@app/api';
import { useGuide } from '@app/hooks/use-guide';
import { Paper } from '@app/components/common';
import Error404 from '@app/pages/errors/404';
import { usePermissions } from '@app/hooks/use-permissions';
import { ROLES } from '@app/navigation/types';
import { useAutocomplete } from '@app/hooks';
import { NewOutlet } from '@app/api/models';

import OutletForm from './form';
import { NewOutletFormInstance } from './types';

export const ViewCreateOutlet = () => {
  useHeader('Заявка на новую ТТ', []);
  const params = useParams<{ id: string }>();

  const { state } = useLocation<{ outlet?: NewOutlet }>();
  const history = useHistory();
  const { error } = useAlert();
  const getAutocomplete = useAutocomplete();

  const [instance, setInstance] = useState<
    NewOutletFormInstance | undefined
  >(undefined);
  
  const getMasterOutletStatus = useGuide(
    'outlet_status',
    undefined,
  );

  const getChannels = useGuide('outlet_sub_channel', undefined);

  useEffect(() => {
    void (async () => {
      
      if(!params.id || !state.outlet) {
        return;
      }
      const { outlet: newOutlet } = state;
      const { data: response } = await api.acb.getNewOutlet(Number(params.id));
      if (response.code !== 200) {
        error(response.message);
        history.goBack();
        return;
      }
      const outlet = response.data;

      let region = await getAutocomplete('region', { search: outlet.address.region });
      let city = await getAutocomplete('city', { search: outlet.address.city });

      const distributor = newOutlet.distributor.id ? (await api.distributors.getDistributors({
        limit: 1,
        offset: 0,
        filter: {
          id: newOutlet.distributor.id.toString(),
        },
        sort: '+id',
      })).data.data.data[0] : undefined;

      let channel, subChannel, routeNumber: EntityBase;

      if(newOutlet.sub_channel?.id !== undefined) {
        const rawChannels = await getChannels();
        const channels = rawChannels.reduce<EntityBase[]>((acc, item, index) => {
            if (acc.find(({ name }) => name === item.channel)) {
              return acc;
            }
            return [...acc, { id: index, name: item.channel }];
          }, []);
        subChannel = rawChannels.find(({ id }) => id === newOutlet.sub_channel.id);
        channel = channels.find(({ name }) => name.toLowerCase() === subChannel?.channel?.toLowerCase());
      }

      if(newOutlet.route_number?.id !== undefined) {
        const { data: response } = await api.acb.getRoute(Number(newOutlet.route_number.id)); 
        if (response.code === 200) {
          routeNumber = response.data;
        }
      }

      region = await getAutocomplete('region', { search: newOutlet.address.region });
      city = await getAutocomplete('city', { search: newOutlet.address.city });

      setInstance({ 
        ...outlet,
        name:  newOutlet.name || outlet?.name,
        address: {
          ...newOutlet.address || outlet?.address,
          region: region?.[0]?.name,
          city: city?.[0]?.name,
        },
        contact_person_1: newOutlet.contact_person_1 || outlet.contact_person_1, 
        contact_person_2: newOutlet.contact_person_2 || outlet.contact_person_2, 
        director: newOutlet.director || outlet.director,
        distributor: distributor || outlet.distributor, 
        email: newOutlet.email || outlet.email, 
        phone: newOutlet.phone || outlet.phone,
        route_number: routeNumber || outlet?.route_number, 
        // status: status || outlet.status,
        channel: channel || outlet.channel,
        sub_channel: subChannel || outlet.sub_channel,
        subnet: newOutlet.subnet || outlet.subnet,
        title: newOutlet.title || outlet.title,
        visits_day: newOutlet.visits_day,
        updater_user: newOutlet.user,
      });
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id, state]);

  const onFormCancel = () => {
    history.push('/acl/new-outlets/');
  };

  const canEdit = usePermissions({ roles: [ROLES.ADMIN, ROLES.CHIEF] });

  if (!canEdit) {
    return <Error404 />;
  }

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 4, lg: 12, xl: 22 }}>
      {!instance ? (
        <Box
          width="100%"
          height="300px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Spinner />
        </Box>
      ) : (<Paper>
        <Box paddingX={4} paddingY={6}>
          <OutletForm
            instance={instance}
            onCancel={onFormCancel}
            onSubmit={() => {}}
            view
          />
        </Box>  
      </Paper>)}
    </Box>
  );
};

export default ViewCreateOutlet;
